
<!-- 


    -------------------------------------------------

    DEPRECATED - DO NOT USE FOR NEW DEVELOPMENT

    -------------------------------------------------
    

    
-->

<template>
    <div class="field-group is-horizontal">
        <slot name="fields">
        </slot>
    </div>
</template>

<script>
export default {
    props: {},
    data () {
        return {
            testprop: 'This is a test!',
        };
    }, 
    mounted() {

    }
};
</script>